export default "__VITE_ASSET__BpA_N9J0__"